export default {
  PROGRESS_STATUS: {
    APPROVAL: 0,
    TAX: 1,
    BANK: 2,
    COMPLETE: 3
  },
  ISSUE_STATE: {
    READY: 0,
    REQUEST_AUTO: 2,
    SUCCESS: 3,
    FAIL: 4
  },
  BANK_STATUS: {
    PROCESSING: 0,
    COMPLETE: 1
  },
  TRADING_APPROVAL_STATUS: {
    READY: 0,
    REQUEST: 1,
    COMPLETE: 2,
    REJECT: 3
  }
};
